<div class="app-message-dialog">
  @if (data?.title) {
    <h2 mat-dialog-title class="text-center">
      {{ data?.title }}
      <mat-divider class="yellow-divider"></mat-divider>
    </h2>
  }
  <mat-dialog-content class="text-center">
    <p>{{ data?.message }}</p>
  </mat-dialog-content>
  <mat-divider class="yellow-divider"></mat-divider>
  <mat-dialog-actions>
    <button mat-flat-button mat-dialog-close>
      {{ data?.buttonText ? data?.buttonText : "OKAY" }}
    </button>
  </mat-dialog-actions>
</div>
